import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-thin",
  "use": "plus-thin-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9 9\" id=\"plus-thin\"><defs><path id=\"plus-thin_a\" d=\"M643 276v-1h4v-4h1v4h4v1h-4v4h-1v-4z\" /></defs><use xlink:href=\"#plus-thin_a\" fill=\"#373f51\" transform=\"translate(-643 -271)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol